(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Kinessia — page collection : panneau de filtres, tri et densité de grille. */
  (function () {
    "use strict";

    function initCollectionPage() {
      var root = document.querySelector("[data-collection-page]");
      if (!root) return;

      var form = root.querySelector("[data-facets-form]");
      var panel = root.querySelector("[data-facets-panel]");
      var openers = root.querySelectorAll("[data-facets-toggle]");
      var closers = root.querySelectorAll("[data-facets-close]");
      var mobile = window.matchMedia("(max-width: 749px)");

      function submitForm() {
        if (!form) return;
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else form.submit();
      }

      /* --- Panneau de filtres : dépliant sur ordinateur, plein écran sur mobile --- */
      function setPanelOpen(open) {
        if (!panel) return;
        panel.toggleAttribute("data-open", open);
        Array.prototype.forEach.call(openers, function (btn) {
          btn.setAttribute("aria-expanded", String(open));
        });
        document.body.style.overflow = open && mobile.matches ? "hidden" : "";
        if (open && mobile.matches) {
          window.setTimeout(function () {
            var first = panel.querySelector("input:not([disabled]), select, button, a[href]");
            if (first) first.focus();
          }, 0);
        }
      }

      Array.prototype.forEach.call(openers, function (btn) {
        btn.addEventListener("click", function () {
          setPanelOpen(!panel.hasAttribute("data-open"));
        });
      });

      Array.prototype.forEach.call(closers, function (btn) {
        btn.addEventListener("click", function () {
          setPanelOpen(false);
          if (openers[0]) openers[0].focus();
        });
      });

      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") return;
        if (!panel || !panel.hasAttribute("data-open")) return;
        setPanelOpen(false);
        if (openers[0]) openers[0].focus();
      });

      if (typeof mobile.addEventListener === "function") {
        mobile.addEventListener("change", function () {
          var isOpen = panel ? panel.hasAttribute("data-open") : false;
          document.body.style.overflow = isOpen && mobile.matches ? "hidden" : "";
        });
      }

      /* --- Tri et cases à cocher : rechargement immédiat sur ordinateur.
             Sur mobile on attend « Voir les résultats » pour éviter un
             rechargement à chaque case cochée dans le panneau. --- */
      if (form) {
        form.addEventListener("change", function (event) {
          var target = event.target;
          if (!target) return;
          if (target.hasAttribute("data-facets-sort")) {
            submitForm();
            return;
          }
          if (target.hasAttribute("data-facet-input") && !mobile.matches) {
            submitForm();
          }
        });
      }

      /* --- Densité de la grille, mémorisée dans localStorage --- */
      var STORAGE_KEY = "kinessia:collection-columns";
      var ALLOWED = ["2", "3", "4"];
      var grid = root.querySelector("[data-collection-grid]");
      var densityButtons = root.querySelectorAll("[data-density]");

      function applyDensity(value) {
        if (grid) grid.style.setProperty("--collection-columns", value);
        Array.prototype.forEach.call(densityButtons, function (btn) {
          btn.setAttribute("aria-pressed", String(btn.getAttribute("data-density") === value));
        });
      }

      if (densityButtons.length) {
        var stored = null;
        try {
          stored = window.localStorage.getItem(STORAGE_KEY);
        } catch (err) {
          stored = null;
        }
        var fallback = (grid && grid.getAttribute("data-default-columns")) || "3";
        applyDensity(ALLOWED.indexOf(stored) !== -1 ? stored : fallback);

        Array.prototype.forEach.call(densityButtons, function (btn) {
          btn.addEventListener("click", function () {
            var value = btn.getAttribute("data-density");
            if (ALLOWED.indexOf(value) === -1) return;
            applyDensity(value);
            try {
              window.localStorage.setItem(STORAGE_KEY, value);
            } catch (err) {
              /* mode privé : on ignore simplement la mémorisation */
            }
          });
        });
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initCollectionPage);
    } else {
      initCollectionPage();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /**
   * Fiche produit Kinessia — galerie, sélecteur d'offres en lot, CTA dynamique,
   * fenêtre de livraison estimée. Vanilla JS, aucune dépendance.
   *
   * Tous les écouteurs "métier" sont posés en délégation sur `document` : ils
   * s'exécutent donc après les écouteurs directs de global.js (phase cible <
   * phase de bulle), ce qui permet de réappliquer l'offre choisie après que le
   * variant picker a réécrit l'input caché `id`.
   *
   * Ce bloc n'évalue pas Liquid : les textes traduits (libellés du bouton,
   * phrase de livraison) et la langue viennent des attributs data-* du HTML.
   */
  (() => {
    "use strict";

    const root = document.querySelector("[data-product-page]");
    if (!root) return;

    const pageLocale = document.documentElement.lang || "fr-FR";
    const euro = (cents) => {
      try {
        return (Number(cents) / 100).toLocaleString(pageLocale, { style: "currency", currency: "EUR" });
      } catch (err) {
        return (Number(cents) / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
      }
    };

    /* ------------------------------------------------------------------ *
     * Galerie : flèches, clavier, zoom. Les vignettes restent gérées par
     * global.js ; les flèches délèguent au clic sur la vignette cible pour
     * ne pas dupliquer la logique.
     * ------------------------------------------------------------------ */
    const gallery = root.querySelector("[data-gallery]");
    if (gallery) {
      const images = Array.from(gallery.querySelectorAll("[data-gallery-image]"));
      const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-thumb]"));

      const activeIndex = () => {
        const i = images.findIndex((img) => img.classList.contains("is-active"));
        return i < 0 ? 0 : i;
      };

      const goTo = (index) => {
        if (images.length < 2) return;
        const target = ((index % images.length) + images.length) % images.length;
        const thumb = thumbs[target];
        if (thumb) {
          thumb.click(); // réutilise le handler global.js
        } else {
          images.forEach((img, i) => img.classList.toggle("is-active", i === target));
        }
      };

      const prevBtn = gallery.querySelector("[data-gallery-prev]");
      const nextBtn = gallery.querySelector("[data-gallery-next]");
      if (prevBtn) prevBtn.addEventListener("click", () => goTo(activeIndex() - 1));
      if (nextBtn) nextBtn.addEventListener("click", () => goTo(activeIndex() + 1));

      gallery.addEventListener("keydown", (event) => {
        if (images.length < 2) return;
        if (event.key === "ArrowLeft") {
          event.preventDefault();
          goTo(activeIndex() - 1);
        } else if (event.key === "ArrowRight") {
          event.preventDefault();
          goTo(activeIndex() + 1);
        }
      });

      const zoomBtn = gallery.querySelector("[data-gallery-zoom]");
      const dialog = gallery.querySelector("[data-gallery-dialog]");
      if (zoomBtn && dialog) {
        const dialogImg = dialog.querySelector("[data-gallery-dialog-image]");
        zoomBtn.addEventListener("click", () => {
          const active = images[activeIndex()];
          if (active && dialogImg) {
            dialogImg.src = active.getAttribute("data-zoom-src") || active.currentSrc || active.src;
            dialogImg.alt = active.alt || "";
          }
          if (typeof dialog.showModal === "function") dialog.showModal();
          else dialog.setAttribute("open", "");
        });
        dialog.addEventListener("click", (event) => {
          if (event.target === dialog || event.target.closest("[data-gallery-dialog-close]")) {
            if (typeof dialog.close === "function") dialog.close();
            else dialog.removeAttribute("open");
          }
        });
      }
    }

    /* ------------------------------------------------------------------ *
     * Buy box
     * ------------------------------------------------------------------ */
    const form = root.querySelector("form[data-product-form]");
    if (!form) return;

    let variants = [];
    const jsonEl = root.querySelector("[data-product-json]");
    if (jsonEl) {
      try {
        variants = JSON.parse(jsonEl.textContent) || [];
      } catch (err) {
        console.error("Kinessia: JSON variantes illisible", err);
      }
    }

    const idInput = form.querySelector("[data-variant-id-input]");
    const atcBtn = form.querySelector("[data-atc]");
    const atcIconTpl = root.querySelector("[data-atc-icon]");
    const priceBadge = form.querySelector("[data-price-badge]");
    const offers = Array.from(form.querySelectorAll("[data-offer]"));
    const qtyInput =
      form.querySelector("[data-offer-quantity-input]") || form.querySelector("input[name='quantity']");

    // global.js réécrit le textContent du bouton submit lors d'un changement de
    // variante ; on relit donc les libellés (traduits côté Liquid) depuis les
    // attributs et on reconstruit le bouton dans sync(), qui passe toujours après.
    const LABEL_ADD = (atcBtn && atcBtn.getAttribute("data-label-available")) || "Ajouter au panier";
    const LABEL_SOLD_OUT = (atcBtn && atcBtn.getAttribute("data-label-sold-out")) || "Rupture de stock";

    function selectedOptionValues() {
      const byPosition = {};
      form.querySelectorAll("[data-option-selector]").forEach((select) => {
        byPosition[select.dataset.optionPosition] = select.value;
      });
      form.querySelectorAll("[data-option-selector-radio]:checked").forEach((radio) => {
        byPosition[radio.dataset.optionPosition] = radio.value;
      });
      return Object.keys(byPosition)
        .sort((a, b) => a - b)
        .map((position) => byPosition[position]);
    }

    function currentVariant() {
      if (!variants.length) return null;
      const selected = selectedOptionValues();
      if (!selected.length) return variants[0];
      return (
        variants.find((variant) => variant.options.every((opt, i) => opt === selected[i])) || variants[0]
      );
    }

    function updateOptionLabels() {
      form.querySelectorAll("[data-option-value]").forEach((slot) => {
        const position = slot.getAttribute("data-option-value");
        const radio = form.querySelector(
          '[data-option-selector-radio][data-option-position="' + position + '"]:checked'
        );
        const select = form.querySelector(
          '[data-option-selector][data-option-position="' + position + '"]'
        );
        const value = radio ? radio.value : select ? select.value : null;
        if (value) slot.textContent = value;
      });
    }

    function updatePriceBadge(variant) {
      if (!priceBadge || !variant) return;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const pct = Math.round(
          ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
        );
        priceBadge.textContent = "-" + pct + "%";
        priceBadge.hidden = false;
      } else {
        priceBadge.textContent = "";
        priceBadge.hidden = true;
      }
    }

    function renderAtc(priceCents, available) {
      if (!atcBtn) return;
      atcBtn.textContent = "";
      if (atcIconTpl && atcIconTpl.content) {
        atcBtn.appendChild(atcIconTpl.content.cloneNode(true));
      }
      const label = document.createElement("span");
      label.textContent = available ? LABEL_ADD : LABEL_SOLD_OUT;
      atcBtn.appendChild(label);
      if (available && priceCents != null && !isNaN(priceCents)) {
        const price = document.createElement("span");
        price.className = "product-main__atc-price";
        price.textContent = "— " + euro(priceCents);
        atcBtn.appendChild(price);
      }
      atcBtn.disabled = !available;
    }

    function sync() {
      const variant = currentVariant();
      updateOptionLabels();
      updatePriceBadge(variant);

      // Les offres "dynamiques" (quantité du produit courant) suivent la variante.
      offers.forEach((offer) => {
        if (offer.getAttribute("data-offer-self") !== "true" || !variant) return;
        const qty = parseInt(offer.getAttribute("data-offer-quantity"), 10) || 1;
        const total = variant.price * qty;
        offer.setAttribute("data-offer-price", String(total));
        offer.setAttribute("data-offer-variant", String(variant.id));
        offer.setAttribute("data-offer-available", variant.available ? "true" : "false");
        const wrap = offer.closest(".pbundle__opt");
        if (!wrap) return;
        const priceLabel = wrap.querySelector("[data-offer-price-label]");
        if (priceLabel) priceLabel.textContent = euro(total);
        const compareLabel = wrap.querySelector("[data-offer-compare-label]");
        if (compareLabel) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareLabel.textContent = euro(variant.compare_at_price * qty);
            compareLabel.hidden = false;
          } else {
            compareLabel.hidden = true;
          }
        }
      });

      const selectedOffer = offers.find((offer) => offer.checked);
      offers.forEach((offer) => {
        const wrap = offer.closest(".pbundle__opt");
        if (wrap) wrap.classList.toggle("is-selected", offer.checked);
      });

      let priceCents = variant ? variant.price : null;
      let available = variant ? variant.available : true;
      let quantity = 1;

      if (selectedOffer) {
        quantity = parseInt(selectedOffer.getAttribute("data-offer-quantity"), 10) || 1;
        priceCents = parseInt(selectedOffer.getAttribute("data-offer-price"), 10);
        available = selectedOffer.getAttribute("data-offer-available") !== "false";
        const offerVariantId = selectedOffer.getAttribute("data-offer-variant");
        if (idInput && offerVariantId) idInput.value = offerVariantId;
        if (qtyInput) qtyInput.value = String(quantity);
      } else if (qtyInput) {
        quantity = parseInt(qtyInput.value, 10) || 1;
        if (variant) priceCents = variant.price * quantity;
      }

      renderAtc(priceCents, available);
    }

    // Délégation sur document : passe après les écouteurs de global.js.
    document.addEventListener("change", (event) => {
      if (!form.contains(event.target)) return;
      if (
        event.target.matches("[data-offer], [data-option-selector], [data-option-selector-radio]") ||
        event.target.matches("input[name='quantity']")
      ) {
        sync();
      }
    });

    sync();

    /* ------------------------------------------------------------------ *
     * Fenêtre de livraison estimée : aujourd'hui + 7 à + 10 jours ouvrés
     * (24-48 h de préparation + 6-8 jours ouvrés de transport, comme la
     * politique d'expédition). Phrase, bornes et langue lues sur l'élément.
     * Aucune notion d'urgence ni de compte à rebours.
     * ------------------------------------------------------------------ */
    const deliverySlot = root.querySelector("[data-pdp-delivery]");
    if (deliverySlot) {
      const textEl = deliverySlot.querySelector("[data-pdp-delivery-text]");
      const locale = deliverySlot.getAttribute("data-locale") || pageLocale;
      const template =
        deliverySlot.getAttribute("data-template") || "Livraison estimée entre le __FROM__ et le __TO__";
      const minDays = parseInt(deliverySlot.getAttribute("data-min-days"), 10) || 7;
      const maxDays = parseInt(deliverySlot.getAttribute("data-max-days"), 10) || 10;
      const addBusinessDays = (days) => {
        const date = new Date();
        let added = 0;
        while (added < days) {
          date.setDate(date.getDate() + 1);
          const day = date.getDay();
          if (day !== 0 && day !== 6) added += 1;
        }
        return date;
      };
      const fmt = (date) => {
        try {
          return date.toLocaleDateString(locale, { day: "numeric", month: "long" });
        } catch (err) {
          return date.toLocaleDateString("fr-FR", { day: "numeric", month: "long" });
        }
      };
      if (textEl) {
        textEl.textContent = template
          .replace("__FROM__", fmt(addBusinessDays(minDays)))
          .replace("__TO__", fmt(addBusinessDays(maxDays)));
        deliverySlot.hidden = false;
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
